import { FaBars, FaUser, FaChartBar, FaBuilding, FaFileAlt, FaClipboardList, FaHome, FaUsers, FaDatabase, FaSignOutAlt, FaTasks, FaShieldAlt, FaBrain, FaRobot, FaExclamationTriangle } from "react-icons/fa";
import { Link , useLocation, useNavigate } from "react-router-dom";
import { useState, useEffect } from "react";
import { apiService } from "../services/apiService";
import { API_ENDPOINTS } from "../config/api";
import { toast } from "react-hot-toast";
import "./dummy.css";

const Sidebar = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [isNavOpen, setIsNavOpen] = useState(false); // Start closed by default
  const userRole = localStorage.getItem("userRole");
  
  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth < 768) {
        setIsNavOpen(false); // Always start closed on mobile
      } else {
        setIsNavOpen(true); // Open on desktop
      }
    };
    
    // Set initial state based on screen size
    handleResize();
    
    // Add event listener for window resize
    window.addEventListener('resize', handleResize);
    
    // Clean up event listener on component unmount
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  const handleNavToggle = () => {
    setIsNavOpen(!isNavOpen);
  };

  // Update layout class for content shifting
  useEffect(() => {
    const layoutElement = document.querySelector('.layout');
    if (layoutElement) {
      if (isNavOpen) {
        layoutElement.classList.add('sidebar-open');
        layoutElement.classList.remove('sidebar-closed');
      } else {
        layoutElement.classList.add('sidebar-closed');
        layoutElement.classList.remove('sidebar-open');
      }
    }
  }, [isNavOpen]);

  const roleBasedMenu = {
    "Lead-Employee": ["/profile", "/dashboard", "/leads", "/clients", "/properties", "/newopp" , "/pipeline", "/tasks", "/exceptions"],
    "Manager": ["/profile", "/dashboard", "/leads", "/clients", "/properties", "/newopp", "/pipeline", "/tasks", "/exceptions", "/ai-agent", "/updateopportunity", "/rrport"],
    "BO-Client": ["/profile", "/dashboard", "/leads", "/clients", "/properties", "/newopp",  "/pipeline" ,"/tasks", "/exceptions", "/rrport", "/updateopportunity"],
    "FE-Property": ["/profile", "/dashboard", "/clients", "/properties", "/tasks", "/exceptions"],
    "Super Admin": ["/profile", "/dashboard", "/leads", "/clients", "/properties", "/newopp", "/pipeline", "/tasks", "/exceptions", "/ai-agent", "/ai-insights", "/updateopportunity", "/rrport", "/employee", "/audit-logs" ],
    "Product-Manager": ["/profile", "/dashboard", "/leads", "/clients", "/properties", "/newopp", "/pipeline", "/tasks", "/exceptions", "/updateopportunity",  "/rrport"]
  };

  const menuItems = {
    "/profile": { name: "Profile", icon: <FaUser /> },
    "/dashboard": { name: "Dashboard", icon: <FaHome /> },
    "/leads": { name: "Leads", icon: <FaClipboardList /> },
    "/clients": { name: "Clients", icon: <FaUsers /> },
    "/properties": { name: "Properties", icon: <FaBuilding /> },
    "/newopp": { name: "Opportunities", icon: <FaChartBar /> },
    "/pipeline": { name: "Pipeline", icon: <FaChartBar /> },
    "/tasks": { name: "Tasks", icon: <FaTasks /> },
    "/ai-agent": { name: "AI Agent", icon: <FaRobot /> },
    "/exceptions": { name: "Exceptions", icon: <FaExclamationTriangle /> },
    "/updateopportunity": { name: "Closed Opportunity", icon: <FaFileAlt /> },
    // "/data": { name: "Data", icon: <FaDatabase /> },
    "/rrport": { name: "Reports", icon: <FaFileAlt /> },
    "/ai-insights": { name: "AI Insights", icon: <FaBrain /> },
    "/employee": { name: "Employee", icon: <FaUsers /> },
    "/audit-logs": { name: "Audit Logs", icon: <FaShieldAlt /> }
  };

  // Check if current path is active
  const isActivePath = (path) => {
    return location.pathname === path;
  };

  // Handle logout
  const handleLogout = async () => {
    try {
      // Call logout API
      await apiService.post(API_ENDPOINTS.auth.logout);
      
      // Clear localStorage
      localStorage.removeItem('authToken');
      localStorage.removeItem('userRole');
      localStorage.removeItem('userId');
      localStorage.removeItem('userEmail');
      localStorage.removeItem('columnVisibilityClient');
      localStorage.removeItem('columnVisibilityProperty');
      
      // Show success message
      toast.success('Logged out successfully');
      
      // Redirect to login
      navigate('/login');
    } catch (error) {
      // Even if logout fails on server, clear local data
      console.error('Logout error:', error);
      
      // Clear localStorage
      localStorage.removeItem('authToken');
      localStorage.removeItem('userRole');
      localStorage.removeItem('userId');
      localStorage.removeItem('userEmail');
      localStorage.removeItem('columnVisibilityClient');
      localStorage.removeItem('columnVisibilityProperty');
      
      // Redirect to login
      navigate('/login');
    }
  };

  return (
    <div className="layout">
      {/* Sidebar */}
      <aside className={`sidebar ${isNavOpen ? "open" : "closed"}`}>
        <button 
          onClick={handleNavToggle} 
          className="toggle-btn"
          aria-label={isNavOpen ? "Close sidebar" : "Open sidebar"}
        >
          <FaBars />
        </button>

        <nav>
          <ul>
            {roleBasedMenu[userRole]?.map((path) => {
              const menuItem = menuItems[path];
              const isActive = isActivePath(path);
              
              return (
                <li key={path}>
                  <Link 
                    to={path}
                    className={isActive ? "active" : ""}
                    data-tooltip={menuItem?.name || path.substring(1)}
                    aria-label={menuItem?.name || path.substring(1)}
                  >
                    {menuItem?.icon || <FaFileAlt />}
                    {isNavOpen && <span>{menuItem?.name || path.substring(1)}</span>}
                  </Link>
                </li>
              );
            })}
          </ul>
          
          {/* Logout Button at Bottom */}
          <div className="sidebar-logout">
            <button
              onClick={handleLogout}
              className="logout-btn"
              data-tooltip="Logout"
              aria-label="Logout"
            >
              <FaSignOutAlt />
              {isNavOpen && <span>Logout</span>}
            </button>
          </div>
        </nav>
      </aside>
    </div>
  );
};

export default Sidebar;
